import { inject } from '@angular/core';
import { MngIconService } from './mng-icon.service';

// Kann verwendet werden um Icons die von MngIconService asynchron geliefert werden über einen route resolver ermitteln zu lassen
// damit die Icons dann in der Component sofort zur Verfügung stehen ohne sich mit dem async handling zu befassen...
//
// z.B.
//
// in route:
// resolve: { icons: createIconResolver('mode_edit') },
//
// in component:
// private readonly icons: ISvgIcons = inject(ActivatedRoute).snapshot.data['icons'];
//
// this.icons['mode_edit']

export const createIconResolver =
  (...iconNames: string[]) =>
  () =>
    inject(MngIconService).resolveSvgIcons(...iconNames);
